@if (hasInstruction()) {
  <div
    class="rounded-xl flex flex-col border border-solid border-[#09223E] min-h-[4.6875rem] w-full relative bg-white"
    >
    <!-- Swipe tooltip
    <div *ngIf="showSwipeTooltip"
      class="absolute -top-14 left-0 right-0 flex justify-center items-center text-sm bg-[#09223E] text-white py-2 px-4 rounded-lg shadow-lg z-10 animate-pulse mx-4">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
      </svg>
      <span>Swipe to navigate</span>
    </div>
    -->
    <!-- Header: Dark blue background with white text -->
    <div class="flex justify-between items-center bg-[#09223E] text-white px-4 py-2 rounded-t-xl">
      <div class="flex gap-2 items-center">
        <span class="text-white font-medium">{{ walkingText }}</span>
      </div>
      <span class="text-white font-medium">{{ calcActionTime() | hour }}</span>
    </div>
    <!-- Body: White background with dark blue text -->
    <div class="px-4 py-3 bg-white rounded-b-xl">
      <span class="text-[#09223E] text-base font-normal">
        {{ action.activeAction.instruction }}
      </span>
    </div>
  </div>
}

<!-- TODO: Complete icons & text -->
<ng-template #actionHeader>
  @switch (action.activeAction.action) {
    @case (actionTypes.DEPART) {
      <ng-icon />
      <!-- <span>{{ departText }}</span> -->
    }
    @case (actionTypes.ARRIVE) {
      <ng-icon />
      <!-- <span>{{ arriveText }}</span> -->
    }
    @case (actionTypes.TURN) {
      <ng-icon />
      <!-- <span>{{ turnText }}</span> -->
    }
    @case (actionTypes.ROUNDABOUT_ENTER) {
      <ng-icon />
      <!-- <span>{{ roundaboutEnterText }}</span> -->
    }
    @case (actionTypes.ROUNDABOUT_PASS) {
      <ng-icon />
      <!-- <span>{{ roundaboutPassText }}</span> -->
    }
  }
</ng-template>
